import { IDENTITYKEY, ACCESSINFOKEY } from '../../services/identityService';
import { AUTHPROVIDERKEY } from '../../authProviders/utilities'

export const DARKMODEKEY = 'cw.darkMode';

export const globalStateActionType = {
    "SIGNIN": "SIGNIN",
    "SIGNOUT": "SIGNOUT",
    "TOGGLE_DARK_MODE": "TOGGLE_DARK_MODE"
}

export const reducer = (state, action) => {
    switch (action.type) {
        case globalStateActionType.SIGNIN:
            const { identityToken, accessToken } = action.value;

            return {
                ...state,
                identityToken,
                accessToken
            };
        case globalStateActionType.SIGNOUT:
            localStorage.removeItem(IDENTITYKEY);
            localStorage.removeItem(ACCESSINFOKEY);
            localStorage.removeItem(AUTHPROVIDERKEY);

            return {
                ...state,
                identityToken: null,
                accessToken: null,
                //isSigningOut: true
            };

        case globalStateActionType.TOGGLE_DARK_MODE:
            const newDarkMode = !state.isDarkMode;
            localStorage.setItem(DARKMODEKEY, JSON.stringify(newDarkMode));

            return {
                ...state,
                isDarkMode: newDarkMode
            };

        default:
            return state;
    }
}

// Load dark mode preference from localStorage
const loadDarkModePreference = () => {
    try {
        const stored = localStorage.getItem(DARKMODEKEY);
        return stored ? JSON.parse(stored) : false;
    } catch {
        return false;
    }
};

export const initialGlobalState = {
    identityToken: null,
    accessToken: null,
    isSigningOut: false,
    isDarkMode: loadDarkModePreference()
};